import { Alert, Box, Text } from '@nimbus-ds/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface OrderProcessingAlertProperties {
  domainName: string;
}

type OrderProcessingAlertProps = OrderProcessingAlertProperties;

export function OrderProcessingAlert({
  domainName,
}: OrderProcessingAlertProps) {
  const t = useTranslationConfigurations('domains');

  return (
    <Alert appearance="warning">
      <Box display="flex" flexDirection="column" gap="2">
        <Text fontSize="caption" fontWeight="bold" color="warning-textLow">
          {t('landing.processingAlert.title', { domainName })}
        </Text>
        <Text fontSize="caption" color="warning-textLow">
          {t('landing.processingAlert.description')}
        </Text>
      </Box>
    </Alert>
  );
}
